var map = {
	"./Marathon.png": "589e",
	"./Marathon_text.png": "7648",
	"./MediBuddy.png": "5c63",
	"./WA_IMG_1.png": "520e",
	"./WA_IMG_2.png": "4aa4",
	"./acadgild.png": "eeb5",
	"./acadgild_founders.jpg": "d222",
	"./apollomunich.jpg": "cc87",
	"./apollomunich_ceo.jpg": "a04b",
	"./features_code.png": "d3fa",
	"./features_handoff.png": "b924",
	"./features_sales.png": "f40c",
	"./features_support.png": "bc6a",
	"./gdpr-lg-grey.png": "82fa",
	"./help.png": "dfdd",
	"./image_bg.jpg": "3553",
	"./info1.png": "5f5b",
	"./info2.png": "44c9",
	"./info3.png": "a011",
	"./info4.png": "afaa",
	"./kaarva.png": "41f0",
	"./kaarva_text.jpg": "4e22",
	"./logo-bottom.png": "6b77",
	"./logo-new-white.png": "6501",
	"./logo-new.png": "980c",
	"./logo-white-1.png": "2ec0",
	"./logo-white.png": "06f1",
	"./nykaa.png": "3f4e",
	"./nykaa_office.jpg": "68a0",
	"./o2-spa.png": "0b2f",
	"./o2spa-office.jpg": "6496",
	"./site_image.png": "dc39",
	"./site_image_old.jpg": "abc5",
	"./test.png": "9165",
	"./top-bg.png": "41d2",
	"./verloop-1.png": "10cd",
	"./verloop-2.png": "de42",
	"./verloop-sample-chat.jpg": "d3b0",
	"./verloop-sample-livechat.png": "2abc",
	"./waterprojects.png": "19a5",
	"./whatsapp.png": "d253",
	"./zapier.png": "580b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f15";